import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4d55fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"16px"} }
const _hoisted_2 = { style: {"font-size":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_tree = _resolveComponent("menu-tree", true)!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMenus, (submenu) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: submenu.router
    }, [
      (submenu.children && submenu.children.length >= 1)
        ? (_openBlock(), _createBlock(_component_el_submenu, {
            key: 0,
            index: submenu.router
          }, {
            title: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass([submenu.icon ? submenu.icon : '', "iconfont icon_logo"])
              }, null, 2),
              _createElementVNode("span", _hoisted_1, _toDisplayString(submenu.name), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_menu_tree, {
                userMenus: submenu.children
              }, null, 8, ["userMenus"])
            ]),
            _: 2
          }, 1032, ["index"]))
        : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: submenu.router,
            onClick: ($event: any) => (_ctx.handleMenuItemClick(submenu))
          }, {
            title: _withCtx(() => [
              (submenu.pid == 0)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass([submenu.icon ? submenu.icon : '', "iconfont icon_logo"])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_2, _toDisplayString(submenu.name), 1)
            ]),
            _: 2
          }, 1032, ["index", "onClick"]))
    ], 64))
  }), 128))
}